module.exports = __webpack_public_path__ + "img/p-banner-98.aac4bb2a.png";